import React from 'react'
import { Button } from 'react-bootstrap'
import {
  faPen,
  faTrash,
  faGripLines,
  faExclamationSquare,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import CommonToolTip from '../../../ui/tooltip/commonToolTip'
import styles from './ListItem.module.scss'

interface IListItem {
  id?: number
  name?: string
  dragDrop: boolean
  onEdit: any
  onDelete: any
  disabled?: boolean
  contentCount?: any
}

const ListItem: React.FC<IListItem> = ({
  id,
  name,
  dragDrop,
  onDelete,
  onEdit,
  disabled = false,
  contentCount = -1,
}) => {
  const { t } = useTranslation()

  const noContent = () => {
    return (
      <CommonToolTip
        text={t('administration.lessons.noContentToolTip')}
        position={'right'}
      >
        <FontAwesomeIcon size={'xs'} icon={faExclamationSquare} />
      </CommonToolTip>
    )
  }

  return (
    <div className={`${styles.listItem} ${dragDrop ? styles.draggable : ''}`}>
      <div className={styles.listItemContent}>
        {dragDrop && (
          <div className={styles.icon}>
            <FontAwesomeIcon icon={faGripLines} className={styles.dragIcon} />
          </div>
        )}
        <p className={styles.name}>
          {name} {contentCount === 0 && !dragDrop && noContent()}
        </p>
        <div className={styles.actions}>
          <Button onClick={() => onEdit(id)} disabled={disabled}>
            <FontAwesomeIcon size={'xs'} icon={faPen} />
          </Button>
          <Button
            onClick={() => onDelete(id, 'hardcoredType:)')}
            disabled={disabled}
          >
            <FontAwesomeIcon size={'xs'} icon={faTrash} />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ListItem
